import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Container, Button } from "react-bootstrap";
import Header from "../../components/header";
import Footer from "../../components/footer";

export default function WelcomePage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [connecting, setConnecting] = useState(false);

  const displayName = useMemo(() => {
    try {
      const raw = localStorage.getItem("allyUser");
      if (!raw) return "there";
      const u = JSON.parse(raw);
      return u.firstName || u.businessEmailAddress || "there";
    } catch {
      return "there";
    }
  }, []);

  useEffect(() => {
    const status = searchParams.get("whatsapp");
    if (status === "connected") {
      window.alert("WhatsApp connected successfully.");
      searchParams.delete("whatsapp");
      searchParams.delete("reason");
      setSearchParams(searchParams, { replace: true });
    } else if (status === "error") {
      const reason = searchParams.get("reason") || "Something went wrong";
      window.alert(`WhatsApp connection failed: ${reason}`);
      searchParams.delete("whatsapp");
      searchParams.delete("reason");
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const connectWhatsApp = useCallback(async () => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      window.alert("Please log in first.");
      navigate("/login");
      return;
    }
    const API_BASE_URL =
      process.env.REACT_APP_API_BASE_URL || "https://ted-talk-phi.vercel.app/api";
    setConnecting(true);
    try {
      const res = await fetch(`${API_BASE_URL}/whatsapp-integration/oauth/start`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(body.message || body.error || `Request failed (${res.status})`);
      }
      if (!body.authorizationUrl) {
        throw new Error("No authorization URL returned from server.");
      }
      window.location.href = body.authorizationUrl;
    } catch (e) {
      console.error(e);
      window.alert(e.message || "Could not start WhatsApp connection.");
      setConnecting(false);
    }
  }, [navigate]);

  return (
    <div className="min-vh-100 d-flex flex-column">
      {/* Top Navbar */}
      <Header/>

       <section className="hero">
        {/* Main Content */}
      <Container className="flex-grow-1 py-5">
        <div className="text-center mb-5">
          <h3 className="h1 hero-family">Hello, {displayName}!</h3>
          <p className="text-muted fw-semibold green-text fs-4">Welcome to Ally!</p>
          <h5 className="mt-4 fw-semibold">Where would you like to get started?</h5>
          <p className="text-secondary">
            Connect your WhatsApp number to unlock all features 
          </p>
        </div>
 {/* Trial Info Section */}
        <Container>
        <div className="bg-fffaed bg-opacity-10 rounded-3 text-center p-4 mt-5 mx-auto" style={{ maxWidth: "800px" }}>
          <h5 className="fw-semibold text-success mb-2 fs-4">
            Ready to use your Live trial account?
          </h5>
          <p className="text-muted mb-3">
            Connect your number to unlock all features like brand messaging and unlimited responses.
          </p>
          <Button
            className="button"
            variant="success"
            type="button"
            disabled={connecting}
            onClick={connectWhatsApp}
          >
            {connecting ? "Redirecting…" : "Connect Number"}{" "}
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16"><path fillRule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708"></path><path fillRule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708"></path></svg>
          </Button>
        </div>  
        </Container>           
           
     
      </Container>
       </section>

      {/* Footer Note */}
     <Footer/>
    </div>
  );
}
